import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@app/material.module';
import { LoaderComponent } from './loader/loader.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SearchComponent } from './search/search.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ConfirmDialogComponent } from './modal/confirmDialog/confirmDialog.component';
import { CustomDialogComponent } from './modal/customDialog/customDialog.component';
import { AddEditSurveyComponent } from './modal/addEditSurvey/addEditSurvey.component';
import { AddEditCognitiveComponent } from './modal/addEditCognitive/addEditCognitive.component';
import { AddEditActivityComponent } from './modal/addEditActivity/addEditActivity.component';
import { AddEditWellBeingComponent } from './modal/addEditWellBeing/addEditWellBeing.component';
import { SurveyDetailTableComponent } from './surveyDetail/surveyDetail.component';
import { SurveyTableComponent } from './survey/survey.component';
import { ActivityTableComponent } from './activity/activity.component';
import { WellBeingTableComponent } from './wellBeing/wellBeing.component';
import { UserListTableComponent } from './userList/userList.component';
import { UserSurveyTableComponent } from './userSurvey/userSurvey.component';
import { SpinnerService } from './spinner/spinner.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NotificationComponent } from './modal/notification/notification.component';
import { NotificationService } from './modal/notification/notification.service';
import { SurveyDetailQuestionFormComponent } from './modal/surveyDetailQuestionForm/surveyDetailQuestionForm.component';

// PrimeNg
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessageService } from 'primeng/api';
import { from } from 'rxjs';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { DocRefPipe } from './pipes/doc-ref.pipe';
import { GetUserByIdPipe } from './pipes/get-user-by-id.pipe';
import { CognitiveComponent } from './cognitive/cognitive.component';
import { UserCognitiveComponent } from './userCognitive/userCognitive.component';
import { GetFormControlsPipe } from './pipes/get-form-controls.pipe';
import { LowercaseDirective } from './directives/lowercase.directive';
import { GetFireDocPipe } from './pipes/get-fire-doc.pipe';

@NgModule({
  imports: [
    FlexLayoutModule,
    NgMultiSelectDropDownModule.forRoot(),
    MaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    CalendarModule,
    SliderModule,
    DialogModule,
    MultiSelectModule,
    AutoCompleteModule,
    ContextMenuModule,
    DropdownModule,
    ButtonModule,
    ToastModule,
    InputTextModule,
    ProgressBarModule,
    TranslateModule,
    FomanticUIModule,
  ],
  declarations: [
    LoaderComponent,
    ConfirmDialogComponent,
    CustomDialogComponent,
    SpinnerComponent,
    AddEditSurveyComponent,
    SurveyDetailQuestionFormComponent,
    AddEditActivityComponent,
    AddEditWellBeingComponent,
    AddEditCognitiveComponent,
    SearchComponent,
    SurveyTableComponent,
    SurveyDetailTableComponent,
    ActivityTableComponent,
    WellBeingTableComponent,
    UserListTableComponent,
    UserSurveyTableComponent,
    NotificationComponent,
    DocRefPipe,
    GetUserByIdPipe,
    CognitiveComponent,
    UserCognitiveComponent,
    GetFormControlsPipe,
    LowercaseDirective,
    GetFireDocPipe,
  ],
  exports: [
    LoaderComponent,
    SearchComponent,
    CustomDialogComponent,
    ConfirmDialogComponent,
    SurveyTableComponent,
    SurveyDetailTableComponent,
    ActivityTableComponent,
    WellBeingTableComponent,
    UserListTableComponent,
    UserSurveyTableComponent,
    SpinnerComponent,
    NotificationComponent,
    DocRefPipe,
    GetUserByIdPipe,
    CognitiveComponent,
    UserCognitiveComponent,
    GetFormControlsPipe,
    LowercaseDirective,
    GetFireDocPipe,
  ],
  providers: [SpinnerService, MessageService, NotificationService],
})
export class SharedModule {}
